import { render, staticRenderFns } from "./BulkUserInviter.vue?vue&type=template&id=24d6a308&"
import script from "./BulkUserInviter.vue?vue&type=script&lang=js&"
export * from "./BulkUserInviter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports